'use strict';

module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/chart.js/src/charts/Chart.Doughnut.js
// module id = ../../../../chart.js/src/charts/Chart.Doughnut.js
// module chunks = 3